import React from 'react';
import { IconProps } from './model/IconInterface';

const CoinIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap='round'
        strokeLinejoin='round'
        aria-hidden
    >
        <circle cx='12' cy='12' r='9' />
        <path d='M15 9a3 3 0 0 0-3-2c-1.66 0-3 1.12-3 2.5S10.34 12 12 12s3 1.12 3 2.5S13.66 17 12 17a3 3 0 0 1-3-2' />
        <path d='M12 6v1.5M12 16.5V18' />
    </svg>
);

export default CoinIcon;
